import 'core-js';
import 'regenerator-runtime/runtime';

import { createApp } from 'vue';
import App from './App.vue';

import router from './router';
import store from './vuex/store';
import i18n from './plugins/i18n';
import icons from './plugins/icons';
import userRoles from './plugins/user-roles';
import axiosPlugin from './plugins/axios';
import dayJsPlugin from './plugins/dayjs';
import ElementPlusPlugin from './plugins/element-ui';
import GlobalComponentsPlugin from './plugins/global-components';
import ConfirmPlugin from './plugins/i-confirm';
import VueSanitize from './plugins/VueSanitize';
import ReCaptchaPlugin from './plugins/recaptcha';
import './plugins/recaptcha';
import './styles/tailwind.css';
import './styles/app.scss';

const app = createApp(App);

const messageHeight = 90;
const messageMarginBottom = 40;

app.config.globalProperties.$refreshCounter = 0;
app.config.globalProperties.$refreshCounterLimit = 30;
app.config.globalProperties.$refreshNotificationsInterval = null;
app.config.globalProperties.$baseHost = import.meta.env.VITE_HOSTURL;
app.config.globalProperties.$getMessageOffsetFromTop = () => window.innerHeight - messageHeight - messageMarginBottom;

const capitalize = (string) => {
  return String(string || '').charAt(0).toUpperCase() + string?.slice(1);
};
String.prototype.capitalize = function() {
  return capitalize(this);
};
app.config.globalProperties.$capitalize = capitalize;
store.$capitalize = capitalize;

// Sanitize configuration
const sanitizeOpts = {
  allowedTags: ['br', 'b'],
  allowedAttributes: {},
  parser: {
    decodeEntities: false,
  },
};

// Use plugins with Vue 3
app.use(VueSanitize, sanitizeOpts);
app.use(icons);
app.use(userRoles, {
  store,
});
app.use(router);
app.use(store);
app.use(i18n);
app.use(axiosPlugin, {
  store,
});
app.use(dayJsPlugin);
app.use(ElementPlusPlugin);
app.use(GlobalComponentsPlugin);
app.use(ConfirmPlugin);
app.use(ReCaptchaPlugin);

// Retrieve token on app creation
app.mixin({
  created() {
    const tokenString = localStorage.getItem('token');
    if (tokenString) {
      this.$store.commit('auth/SET_TOKEN_DATA', tokenString);
    }
  },
});

// Mount the application
app.mount('#app');
